// AXIS ZERO - Orientation Hint
// Shows a hint to rotate phone in portrait mode

import React, { useState, useEffect } from 'react';
import { RotateCcw } from 'lucide-react';

export const OrientationHint = ({ showOnGameplay = false }) => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      const portrait = window.innerHeight > window.innerWidth;
      setIsPortrait(portrait);
      // Reset dismissed when switching to landscape
      if (!portrait) {
        setDismissed(false);
      }
    };

    // Initial check
    checkOrientation();

    // Listen for resize and orientation change
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', () => {
      // Delay check after orientation change
      setTimeout(checkOrientation, 100);
    });

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  // Don't show if not in portrait or if dismissed
  if (!isPortrait || dismissed) {
    return null;
  }

  return (
    <div 
      data-testid="orientation-hint"
      className="fixed bottom-4 left-4 right-4 z-[80] flex items-center justify-center"
    >
      <div 
        className="flex items-center gap-3 px-4 py-3 rounded-lg max-w-xs"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          border: '1px solid rgba(0, 240, 255, 0.5)',
          boxShadow: '0 0 20px rgba(0, 240, 255, 0.2)',
        }}
      >
        {/* Rotating phone icon */}
        <div 
          className="animate-pulse"
          style={{ color: '#00F0FF' }}
        >
          <RotateCcw size={24} />
        </div>
        
        {/* Message */}
        <div className="flex-1">
          <p 
            className="text-sm font-medium"
            style={{ 
              color: '#00F0FF',
              fontFamily: '"Rajdhani", sans-serif',
            }}
          >
            Rotate your phone
          </p>
          <p 
            className="text-xs"
            style={{ color: 'rgba(255, 255, 255, 0.5)' }}
          >
            Best played in landscape
          </p>
        </div>

        {/* Dismiss button */}
        <button
          data-testid="orientation-hint-dismiss"
          onClick={() => setDismissed(true)}
          className="p-1 rounded hover:bg-white hover:bg-opacity-10 transition-colors"
          style={{ color: 'rgba(255, 255, 255, 0.4)' }}
        >
          <span className="text-lg">×</span>
        </button>
      </div>
    </div>
  );
};

export default OrientationHint;
